module.exports = __webpack_public_path__ + "img/30.cd64c6e6.jpg";